module.exports = __webpack_public_path__ + "img/search.eb416c09.svg";